module.exports = __webpack_public_path__ + "img/7e3bb80.png";